import { Injectable, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ToasterService } from 'angular2-toaster';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { timeout, catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  public baseUrl: any; 
  public url: any;
  public tid: any;
  public _tid: any;
  public userId: any;
  public accessToken: any;
  public uid: any;
  public orgID: any;
  public cdnURL : any; 
  public registerId: string;
  public appCode: string;
  twoFactor: string;
  mobNumber: string;
  countryCode: string;
  partyEmail: string;
  userData: string;
  encryptedPassword: string;
  mallCode: string;
  userSelectedMallCode: string;
  userCode: string;
  countryTelCode: string;
  projectURL: string;
  userDetails = {
    userId:'',
    email:'',
    mobileNumber:null,
    countryCode:'',
    userName:'',
    countryTeleCode:''
  };
  dobobj ;
  genderobj ;
  ObjRunTimeConfig: any;
  redirectParam: string ;
  privacyLink: string;
  termsLink: string;
  public projectIspId:any;
  public projectLocation:any;
  public projectArea:any;
  encryptedPass: any;
  appID: any;
  userName: any;

  constructor(public http: HttpClient, private toasterService: ToasterService,private routes: Router) { }

  getLocalStorageData(){
    console.log(window.localStorage.getItem('url'))
    if(window.localStorage.getItem('url')){
      console.log("inside config service");
      this.baseUrl = window.localStorage.getItem('url');
      this.url = window.localStorage.getItem('url') + '/ipos/rest/bpm/process';
      this.cdnURL = window.localStorage.getItem('cdnURL');
      this.appCode = window.localStorage.getItem('appCode');
      this._tid = window.localStorage.getItem('_tid');
      this.tid = window.localStorage.getItem('tid');
      this.registerId = window.localStorage.getItem('registerId');
      this.accessToken = window.localStorage.getItem('accessToken')
      this.userId = window.localStorage.getItem('userIdFromURL');
      this.userCode = window.localStorage.getItem('userCode');
      this.twoFactor = window.localStorage.getItem('twoFactor');
      this.mobNumber = window.localStorage.getItem('mobileNumber');
      this.countryCode = window.localStorage.getItem('countryCode');
      this.countryTelCode = window.localStorage.getItem('countryTelCode');
      this.partyEmail = window.localStorage.getItem('partyEmail');
      this.userSelectedMallCode = window.localStorage.getItem('userSelectedMallCode'); // select mall component
      this.mallCode = window.localStorage.getItem('mallCode'); // from url
      this.userData = window.localStorage.getItem('userData');
      this.encryptedPassword = window.localStorage.getItem('password');
      this.projectURL = window.localStorage.getItem('projectURL');
      this.redirectParam = window.localStorage.getItem('redirectParam');

      this.privacyLink =  localStorage.getItem("privacy");
      this.termsLink =  localStorage.getItem("terms");
       this.projectIspId = localStorage.getItem('IspId'),
      this.projectLocation = localStorage.getItem('Location');
      this.projectArea = localStorage.getItem('Area');

      console.log(this.url, this.cdnURL);
    }
    else{
      this.routes.navigate(['fynd-login']);
    }
  }


  // setConfigJson(json){
  //   this.ObjRunTimeConfig = json 
  //   console.log(this.ObjRunTimeConfig);
    
  // }
  // fetchConfigJson(){
  //   return this.ObjRunTimeConfig;
  // }


getIPaddress(accessToken, userid) {
    return new Promise((resolve) => {
  this.setBlankLocation()
  this.http.get<{ ip: string }>('https://api.ipify.org?format=json')
    .pipe(
      timeout(5000),
      catchError(() => of({ ip: null })),
      switchMap(res => {
        if (!res.ip) {
          this.setBlankLocation();
          return of(null);
        }
        return this.http.post<any>(
          `${this.baseUrl}/ipos/rest/JRConversion/GetLocationV1?tenantId=${this._tid}`,
          { ip: res.ip },
          {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'access_Token': accessToken,
              'userid': userid,
            })
          }
        ).pipe(
          timeout(5000),
          catchError(() => of(null))
        );
      })
    )
    .subscribe(result => {
      if (!result || !result.data || !result.data.Location || result.message.code !== 0) {
        this.setBlankLocation();
        resolve(); 
        return;
      }
      const { ip, city, longitude, latitude } = result.data.Location;
      localStorage.setItem('IspId', ip);
      localStorage.setItem('Area', city);
      localStorage.setItem(
        'Location',
        JSON.stringify({ longitude, latitude })
      );
      this.setAdditionalHeaders(ip, city, { longitude, latitude });
         resolve();
    });
      });
}

private setBlankLocation() {
  localStorage.setItem('IspId', '');
  localStorage.setItem('Area', '');
  localStorage.setItem(
    'Location',
    JSON.stringify({ longitude: '', latitude: '' })
  );
  this.setAdditionalHeaders('', '', { longitude: '', latitude: '' });
}

setAdditionalHeaders(projectIspId, projectArea, projectLocation) {
  this.projectIspId = projectIspId;
  this.projectArea = projectArea;
  this.projectLocation = projectLocation;
}

}